import * as Yup from 'yup';
import { ScenarioInput } from 'src/graphql/_generated';

export const scenarioValidationSchema = Yup.object({
  name: Yup.string().required('Required'),
  source: Yup.number().nullable(),
  event: Yup.number().nullable(),
  consequence: Yup.number().nullable(),
  riskNarrative: Yup.string().nullable(),
  frequencyTimes: Yup.number().nullable(),
  frequencyYears: Yup.number().nullable(),
  frequencyNote: Yup.string().nullable(),
  upperFormula: Yup.string(),
  lowerFormula: Yup.string(),
  consequenceNote: Yup.string().nullable(),
  riskIdentifiedDate: Yup.string().nullable(),
  reviewDate: Yup.string().nullable(),
  status: Yup.string().nullable(),
  managementStrategy: Yup.string().nullable(),
  managementNote: Yup.string().nullable(),
});

export const scenarioInitialValues: ScenarioInput = {
  name: '',
  source: undefined,
  event: undefined,
  consequence: undefined,
  riskOwner: null,
  riskNarrative: '',
  frequencyTimes: undefined,
  frequencyYears: undefined,
  frequencyNote: '',
  upper: undefined,
  lower: undefined,
  upperFormula: '',
  lowerFormula: '',
  consequenceNote: '',
  riskIdentifiedDate: null,
  reviewDate: null,
  status: 'Draft',
};
